import { DataModel, YesNoEnum } from '@shared';
import { LoggingService } from '@shared/logging';
import { RxCollectionCreator } from 'rxdb';
import { MigrationSchemaBuilder } from '../migration-schema.builder';
import { MigrationStep } from '../migration-step.interface';

export class MigrationV1 extends MigrationStep {
	public version = 1;

	public constructor(protected loggingService: LoggingService) {
		super(loggingService);
	}

	public applyMigrationOnSchema(collectionToMigrate: RxCollectionCreator): RxCollectionCreator {
		if (!collectionToMigrate) {
			this.loggingService.error(
				'MigrationV1',
				'Please provide the collection  on which you want to apply the migration'
			);
			throw new Error('Please provide the collection on which you want to apply the migration');
		}

		if (!collectionToMigrate.migrationStrategies) {
			collectionToMigrate.migrationStrategies = {};
		}

		collectionToMigrate.migrationStrategies[this.version] = (oldDoc: DataModel) => {
			const newDoc = { ...oldDoc };

			newDoc.isDeleted = false;
			newDoc.external_created_record = oldDoc.external_created_record
				? oldDoc.external_created_record
				: YesNoEnum.No.toString();
			newDoc.external_modified_record = oldDoc.external_modified_record
				? oldDoc.external_modified_record
				: YesNoEnum.Yes.toString();

			return newDoc;
		};

		if (this.shouldSkipMigration(collectionToMigrate.schema.version)) {
			if (this.hasNext()) {
				return this.getNext().applyMigrationOnSchema(collectionToMigrate);
			} else {
				return collectionToMigrate;
			}
		}

		const migratedSchema = new MigrationSchemaBuilder(collectionToMigrate.schema)
			.setSchemaVersion(this.version)
			.addNewProperty('isDeleted', 'boolean')
			.addNewProperty('external_modified_record', 'string')
			.addNewProperty('external_created_record', 'string')
			.build();

		this.loggingService.info(
			'MigrationV1.applyMigrationOnSchema, migratedSchema version: ',
			JSON.stringify(migratedSchema.version)
		);

		collectionToMigrate = { ...collectionToMigrate, schema: migratedSchema, autoMigrate: false };

		if (this.hasNext()) {
			return this.getNext().applyMigrationOnSchema(collectionToMigrate);
		}

		return collectionToMigrate;
	}
}
